import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import FlashMessage from './FlashMessage';

export default function Layout({ children }) {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <div className="flex min-h-screen flex-col">
            <Header onMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)} />

            <div className="flex flex-1">
                <Sidebar mobileOpen={mobileMenuOpen} onMobileClose={() => setMobileMenuOpen(false)} />

                <main className="flex-1 min-w-0 py-4">
                    <FlashMessage />
                    {children}
                </main>
            </div>

            <Footer />
        </div>
    );
}
